export const keyCodeGeneratorService = {
    methods: {
        keyCode(key) {
            return Math.random().toString(36) + key;
        }
    }
};